<template>
  <div class="s-financialInsurance-container container">
    <topNav></topNav>
    <div class="topBg">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <!--保险--->
    <div class="section-insurance w1300 marginAuto" v-if="insuranceList.length > 0">
      <div class="sectionList" v-for="(item, index) in insuranceList" :key="index">
        <div class="sectionList-item">
          <img :src="defaultImg" alt="" class="bankLogo" v-if="item.img == null || item.img == ''">
          <img v-else :src="item.img.indexOf('http') >= 0 ? item.img : imgURL + '/' + item.img" alt="" class="bankLogo" />
          <div class="section-content">
            <p class="title">{{ item.insuranceName || '--' }}</p>
            <p class="describe">
              <i class="el-icon-arrow-right color-green"></i>
              <span>适用人群：{{ item.applicablePeople || '--' }}</span>
            </p>
            <p class="describe">
              <i class="el-icon-arrow-right color-green"></i>
              <span>投保作物：{{ item.safeguardItems || '--' }}</span>
            </p>
            <p class="describe">
              <i class="el-icon-arrow-right color-green"></i>
              <span>保障范围：{{ item.scopeApplication || '--' }}</span>
            </p>
            <p class="describe">
              <i class="el-icon-arrow-right color-green"></i>
              <span>保障期限：{{ item.term || '--' }}</span>
            </p>
            <p class="price">
              <span class="price-nomall-red">￥</span>
              <span class="price-num-red">{{ item.amountInsured || '--' }}</span>
              <span class="price-nomall-red">元/亩起</span>
            </p>
            <span class="detail-btn" @click="goDetail(item)">了解详情</span>
          </div>
        </div>
      </div>
      <div class="s-transaction-pagination">
        <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next"
          @current-change="currentChange" :total="total"></el-pagination>
      </div>
    </div>
    <div class="w1300 marginAuto" v-else>
      <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>
    <footerNav></footerNav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { getInsuranceSelectListByPage } from "../utils/api/financialInsurance";
export default {
  name: "insurance",
  components: { topNav, footerNav },
  data() {
    return {
      insuranceList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      imgUrlIn: "",
      defaultImg: require("../assets/image/dealmakers/default.png"),
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    this.getInsuranceSelectListByPage();
  },
  methods: {
    async getInsuranceSelectListByPage() {
      let data = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        release: 1
      }
      let res = await getInsuranceSelectListByPage(data);
      if (res.data.code == 0 || res.data.code == 200) {
        this.insuranceList = res.data.data.records;
        this.insuranceList.forEach(item => {
          if (item.img && item.img[item.img.length - 1] == ',') {
            item.img = item.img.slice(0, item.img.length - 1)
            console.log(item.img);
          }
        })
        this.total = res.data.data.total;
      }
    },
    currentChange(value) {
      this.currentPage = value;
      this.getInsuranceSelectListByPage();
    },
    goDetail(item) {
      this.$router.push({ path: '/insuranceDetail', query: { id: item.id } });
    }
  },
};
</script>
<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/financialInsurance.scss";
.s-financialInsurance-container{
  .el-empty__description{
		p{
			font-size: 16px;
		}
  }
}
</style>
<style lang="scss" scoped></style>